<template>
  <div id="unauthorized">
    <div class="container-fluid pt-4">
      <div class="section-title">
        Xml Import Dashboard
      </div>
      <div class="row">
        <div class="col-lg-12">
          <InProgress />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <Global />
        </div>
      </div>
      <div
        class="row"
        style="margin-top: 20px;"
      >
        <div class="col-lg-12">
          <ImageProcessingReport />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Global from './global.vue';
import InProgress from './inprogress.vue';
import ImageProcessingReport from './imageprocessingreport.vue';

export default {
    components: {
        Global, InProgress, ImageProcessingReport
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/Index.vue